/* 
Принимает параметр который получаем из функции currentDate
Она собирает текущую дату
если в названии региона есть major то ничего не генерируем
если месяц можно трансформировать в число то это статистика за год
*/

export function monthGenerator (date,isMajor = false){
  const array = ['Общая'];
  const start = "02/21"
  let current = date;
  let [month,year] = current.value.split('/');

  if(!isMajor){
    array.push('20' + year)
    array.push(date.value)
    while(current !== start){
      if(Number(month) === 1){
        month = 12
        year--;
        array.push('20' + year)
      } else {
        month--;
      }
      current = String(month).padStart(2,0)+"/"+year;
      array.push(current);
    }
  }
  return array.map(item => ({value: item, label: item}));
}